import RoleService from '@/shared/services/RoleService'
import { useQuery } from '@tanstack/react-query'
import { roleQueryKeys } from '../keys/role.query-keys'

export const useRoleMenu = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: roleQueryKeys.menu(),
    queryFn: () => RoleService.getMenu(),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: options?.enabled,
  })
